import React, { PropsWithChildren } from 'react';
import { useSiteConfig } from '@/context/SiteConfigContext';
import LoadingScreen from './LoadingScreen';
import ConnectionErrorScreen from './ConnectionErrorScreen';

/**
 * AppStartupGate
 *
 * A tiny gate component that blocks rendering of the application tree until
 * site configuration has been resolved by `SiteConfigProvider`.
 * - While loading: renders a full-screen loading screen.
 * - On error (and no ready config): renders a connection error screen with Retry.
 * - When ready: renders its children.
 *
 * Keep this component colocated under components/bootstrap but you can import it
 * anywhere as the default export. File name remains BootstrapGate for history,
 * but the exported component is AppStartupGate.
 */
export default function AppStartupGate({ children }: PropsWithChildren) {
  const { isReady, loading, error } = useSiteConfig();

  if (!isReady && loading) return <LoadingScreen />;
  if (!isReady && error) return <ConnectionErrorScreen />;
  return <>{children}</>;
}
